
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loan-terms",
      function () {
        return require("private-next-pages/loan-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loan-terms"])
      });
    }
  